import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectPackagings = (state: RootState) =>
  sortBy(state.packagings.packagings, 'name');

export const selectPackagingErrors = (state: RootState) =>
  state.packagings.errors;
